export default __webpack_public_path__ + "static/media/ico-synonyme.fc837523.svg";